import React from 'react';
import styles from './ImageModal.module.css';
import { IoClose } from 'react-icons/io5';

const ImageModal = ({ imageUrl, onClose }) => {
  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose();
    }
  };

  return (
    <div className={styles.overlay} onClick={handleOverlayClick}>
      <div className={styles.modal}>
        <button className={styles.closeButton} onClick={onClose}>
          <IoClose size={24} />
        </button>
        <img src={imageUrl} alt="Full size preview" className={styles.image} />
      </div>
    </div>
  );
};

export default ImageModal;